var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _vm.$store.getters.roleID === _vm.Roles.SUPER_ADMIN
      ? _c(
          "div",
          { staticClass: "col-lg-6 lbv-engineer-booking" },
          [
            _c("b-card", { attrs: { header: "Book Engineer" } }, [
              _c(
                "div",
                { staticClass: "form-row" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        disabled: !_vm.leakStatusLeaking,
                        variant: "primary",
                      },
                      on: { click: _vm.book },
                    },
                    [_vm._v("\n          Book Engineer\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showBookingForm
                ? _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "booking-form",
                          attrs: { header: "Engineer Booking Form" },
                        },
                        [
                          _c(
                            "b-container",
                            { attrs: { fluid: "" } },
                            [
                              _c(
                                "b-form",
                                [
                                  _c(
                                    "b-form-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            sm: "4",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "bookDate" } },
                                            [_vm._v("Date")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { sm: "8" } },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "bookDate",
                                              type: "date",
                                              min: _vm.getMinDate,
                                              max: _vm.getMaxDate,
                                              disabled: !_vm.formEnabled,
                                            },
                                            model: {
                                              value: _vm.date,
                                              callback: function ($$v) {
                                                _vm.date = $$v
                                              },
                                              expression: "date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            sm: "4",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "bookTime" } },
                                            [_vm._v("Time")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { sm: "8" } },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "bookTime",
                                              type: "time",
                                              disabled: !_vm.formEnabled,
                                            },
                                            model: {
                                              value: _vm.time,
                                              callback: function ($$v) {
                                                _vm.time = $$v
                                              },
                                              expression: "time",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            sm: "4",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "bookRegion" } },
                                            [_vm._v("Region")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { sm: "8" } },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              id: "bookRegion",
                                              options: _vm.regions,
                                              type: "time",
                                              disabled: !_vm.formEnabled,
                                            },
                                            model: {
                                              value: _vm.selectedRegion,
                                              callback: function ($$v) {
                                                _vm.selectedRegion = $$v
                                              },
                                              expression: "selectedRegion",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: {
                                            sm: "4",
                                            "align-self": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "bookName" } },
                                            [_vm._v("Primary Eng Name")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { sm: "8" } },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "bookName",
                                              type: "text",
                                              disabled: !_vm.formEnabled,
                                            },
                                            model: {
                                              value: _vm.engName,
                                              callback: function ($$v) {
                                                _vm.engName = $$v
                                              },
                                              expression: "engName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-row",
                                    { staticClass: "book-form-buttons" },
                                    [
                                      _vm.formEnabled
                                        ? _c(
                                            "b-btn",
                                            {
                                              attrs: { variant: "primary" },
                                              on: { click: _vm.validate },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Save\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.bookingExists && !_vm.formEnabled
                                        ? _c(
                                            "b-btn",
                                            {
                                              attrs: { variant: "secondary" },
                                              on: { click: _vm.editBooking },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Edit\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.bookingExists
                                        ? _c(
                                            "b-btn",
                                            {
                                              attrs: { variant: "danger" },
                                              on: { click: _vm.cancel },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(_vm.cancelLabel) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-modal",
                            {
                              ref: "confirmBooking",
                              attrs: {
                                id: "confirm-booking",
                                title: "Confirm booking details",
                                "ok-variant": "primary",
                                "ok-title": "Confirm Booking",
                                "cancel-variant": "secondary",
                                "cancel-title": "Cancel",
                              },
                              on: { ok: _vm.save },
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n              Please confirm the information is correct and the time has been\n              populated in the customers time zone\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("Date: "),
                                _c("strong", [_vm._v(_vm._s(_vm.date))]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("Time: "),
                                _c("strong", [_vm._v(_vm._s(_vm.time))]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("Country: "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.selectedRegion)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("Engineer Name: "),
                                _c("strong", [_vm._v(_vm._s(_vm.engName))]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-modal",
                            {
                              ref: "confirmCancel",
                              attrs: {
                                id: "confirm-cancel",
                                title: "Cancel Booking",
                                "ok-variant": "danger",
                                "ok-title": "Confirm Cancellation",
                                "cancel-variant": "secondary",
                                "cancel-title": "Cancel",
                              },
                              on: { ok: _vm.cancelBooking },
                            },
                            [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    "Please confirm the engineer visit is no longer required,\n                a cancel will result in an account status change"
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-lg-6 lbv-engineer-booking" },
      [
        _c(
          "b-card",
          { attrs: { header: "Mark as engineer repaired" } },
          [
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.confirm-repaired",
                        modifiers: { "confirm-repaired": true },
                      },
                    ],
                    ref: "repairedBtn",
                    attrs: {
                      variant: "primary",
                      disabled: !_vm.leakStatusLeaking,
                    },
                  },
                  [_vm._v("\n          Leak Repaired\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  id: "confirm-repaired",
                  title: "Confirm repaired",
                  "ok-variant": "danger",
                  "ok-title": "Mark as repaired",
                  "cancel-variant": "primary",
                  "cancel-title": "Cancel",
                },
                on: { ok: _vm.markAsRepaired },
              },
              [
                _c("p", [
                  _c("strong", [_vm._v("This change cannot be undone.")]),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("Has this leak been confirmed repaired?")]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }